import {
  type Block,
  type BlockNoteEditor,
  BlockNoteSchema,
  defaultBlockSpecs,
  defaultStyleSpecs,
} from "@blocknote/core";
import { Font } from "./Font";
import { AppointmentLinkBlockSpec } from "./blocks/AppointmentLinkBlock/AppointmentLinkBlockSpec";
import { ButtonBlockSpec } from "./blocks/ButtonBlock/ButtonBlockSpec";
import { DividerBlockSpec } from "./blocks/DividerBlock/DividerBlockSpec";
import { FormLinkBlockSpec } from "./blocks/FormLinkBlock/FormLinkBlockSpec";
import { ImageBlockSpec } from "./blocks/ImageBlock/ImageBlockSpec";
import { ColumnBlock } from "./blocks/ImageWithChildrenBlock/Column";
import { ImageWithChildrenBlockSpec } from "./blocks/ImageWithChildrenBlock/ImageWithChildrenBlockSpec";
import { PageBlockSpec } from "./blocks/PageBlock/PageBlockSpec";
import { SocialLinksBlockSpec } from "./blocks/SocialLinksBlock/SocialLinksBlockSpec";
import { TwoImagesBlockSpec } from "./blocks/TwoImagesBlock/TwoImagesBlockSpec";
import { VideoBlockSpec } from "./blocks/VideoBlock/VideoBlockSpec";

const blockSpecs = {
  paragraph: defaultBlockSpecs.paragraph,
  heading: defaultBlockSpecs.heading,
  bulletListItem: defaultBlockSpecs.bulletListItem,
  numberedListItem: defaultBlockSpecs.numberedListItem,
  buttonBlock: ButtonBlockSpec,
  pageBlock: PageBlockSpec,
  formLinkBlock: FormLinkBlockSpec,
  appointmentLinkBlock: AppointmentLinkBlockSpec,
  videoBlock: VideoBlockSpec,
  socialLinksBlock: SocialLinksBlockSpec,
  imageBlock: ImageBlockSpec,
  dividerBlock: DividerBlockSpec,
  twoImagesBlock: TwoImagesBlockSpec,
  imageWithChildrenBlock: ImageWithChildrenBlockSpec,
  columnBlock: ColumnBlock,
};

// First create the schema without suggestion items
export const Schema = BlockNoteSchema.create({
  blockSpecs,
  styleSpecs: {
    ...defaultStyleSpecs,
    font: Font,
  },
});

export type BnBlock = Block<typeof Schema.blockSchema, typeof Schema.inlineContentSchema, typeof Schema.styleSchema>;

export type BnEditor = BlockNoteEditor<
  typeof Schema.blockSchema,
  typeof Schema.inlineContentSchema,
  typeof Schema.styleSchema
>;
